"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RepositoryPrivateVisibilityOptions = void 0;
var RepositoryPrivateVisibilityOptions;
exports.RepositoryPrivateVisibilityOptions = RepositoryPrivateVisibilityOptions;
(function (RepositoryPrivateVisibilityOptions) {
  RepositoryPrivateVisibilityOptions["NameAllowed"] = "allowed";
  RepositoryPrivateVisibilityOptions["NameNotAllowed"] = "notallowed";
})(RepositoryPrivateVisibilityOptions || (exports.RepositoryPrivateVisibilityOptions = RepositoryPrivateVisibilityOptions = {}));